﻿

var productImage = undefined;
var productImages = undefined;
var zoomImage = undefined;
let imageYOffset = undefined;
let firstHover = undefined;
let zoomPreview = undefined;

const initProductImageZoom = (slideActiveImage) => {
    if (window.innerWidth > 767) {
        productImage = document.getElementById('productImage');
        // productImages = document.getElementsByClassName('productImageSlide');
        zoomImage = document.getElementById('zoomImage');
        imageYOffset = 0;
        firstHover = true;
        zoomPreview = document.getElementById("zoom-preview");

        //mouseOver();
        if (slideActiveImage != undefined) {
            activeImage = slideActiveImage;
        }
        else {
            var activeImage = document.getElementsByClassName('productImageSlide swiper-slide-active')[0]?.getElementsByTagName('img')[0];
            if (activeImage == undefined) {
                activeImage = document.getElementsByClassName('productImageSlide')[0]?.getElementsByTagName('img')[0];
            }
        }

        if (activeImage == undefined) {
            return;
        }

        let zoomUrl = activeImage.getAttribute("data-zoom-src");
        if (zoomUrl == undefined) {
            zoomUrl = activeImage.getAttribute("src");
        }

        if (zoomUrl == undefined) {
            return;
        }

        let hiddenZoomImage = document.getElementById('hidden-zoom-image');
        document.getElementById('hidden-zoom-image').src = zoomUrl;
        zoomImage.style.backgroundImage = `url(${zoomUrl})`;
        zoomImage.style.backgroundSize = `300%`; // Set the zoom factor here

        setTimeout(function () {
            const imageHeight = activeImage.getBoundingClientRect().height;
            const frameHeight = productImage.getBoundingClientRect().height;
            imageYOffset = (100 - (imageHeight * 100 / frameHeight)) / 2;

            productImage.removeEventListener('mouseover', mouseOverEvent);
            productImage.removeEventListener('mouseout', mouseOutEvent);
            productImage.removeEventListener('mousemove', mouseMoveEvent);

            productImage.addEventListener('mouseover', mouseOverEvent);
            productImage.addEventListener('mouseout', mouseOutEvent);
            productImage.addEventListener('mousemove', mouseMoveEvent);
        }, 0);

    }
};

const mouseOverEvent = () => {
    //setTimeout(() => { mouseOver(); }, 100);
    // mouseOver(); 
    zoomImage.style.display = 'block';
    zoomPreview.style.display = 'block';
    // firstHover = false;
}

const mouseOutEvent = () => {
    zoomImage.style.display = 'none';
    zoomPreview.style.display = 'none';
    // firstHover = 1;
}

const mouseMoveEvent = (event) => {
    zoomImage.style.display = 'block';
    zoomPreview.style.display = 'block';

    const { offsetX, offsetY } = event;
    const { width: containerWidth, height: containerHeight } = productImage.getBoundingClientRect();

    // calculate the position of the zoomed image
    const xPercentage = (offsetX / containerWidth) * 100;
    let yPercentage = (offsetY / containerHeight) * 100;

    // add the offset if image is not square
    yPercentage = yPercentage - imageYOffset;

    // Center the zoomed image on the cursor and boundaries
    if (xPercentage >= 0) {
        if (xPercentage > 100) {
            const backgroundPosition = `${100}% ${yPercentage}%`;
            zoomImage.style.backgroundPosition = backgroundPosition;
        } else {
            if (yPercentage <= 0) {
                const backgroundPosition = `${xPercentage}% ${0}%`;
                zoomImage.style.backgroundPosition = backgroundPosition;
            }
            else if (yPercentage >= 100) {
                const backgroundPosition = `${xPercentage}% ${100}%`;
                zoomImage.style.backgroundPosition = backgroundPosition;
            }
            else {
                const backgroundPosition = `${xPercentage}% ${yPercentage}%`;
                zoomImage.style.backgroundPosition = backgroundPosition;
            }
        }
    }

    // Position the zoom preview rectangle
    const previewSize = 150; // Adjust the size of the zoom preview rectangle as needed
    const previewHalfSize = previewSize / 2;
    const left = (offsetX - previewHalfSize)
    const top = (offsetY - previewHalfSize);
    if (zoomPreview != '') {
        zoomPreview.style.width = `${previewSize}px`;
        zoomPreview.style.height = `${previewSize}px`;
        if (left > 0 && left < containerWidth - previewSize)
            zoomPreview.style.left = `${left}px`;
        if (top > 0 && top < containerHeight - previewSize)
            zoomPreview.style.top = `${top}px`;
    }
}

export default initProductImageZoom;